import { FC } from 'react'
import { Col, Input, Radio, Row, Select } from 'antd'

// import { RiSearchLine } from 'react-icons/ri'
import { BroadcastStatus } from 'types'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { setQuery, setStatus, setView } from 'slices/broadcasts'
import { RiLineChartLine, RiListCheck } from 'react-icons/ri'
import styles from './styles.module.scss'

const { Search } = Input

const BroadcastsFilters: FC = () => {
	const { status: selectedStatus, view } = useAppSelector(
		state => state.broadcasts
	)
	const dispatch = useAppDispatch()

	const onQuery = (value: string) => {
		dispatch(setQuery(value))
	}

	const onStatus = (value: BroadcastStatus) => {
		dispatch(setStatus(value))
	}

	const onView = (value: 'LIST' | 'STATS') => {
		dispatch(setView(value))
	}

	return (
		<Row gutter={12} align='middle' className={styles.broadcastFilters}>
			<Col hidden={view !== 'LIST'}>
				<Search
					onSearch={value => onQuery(value)}
					placeholder='Search Broadcast Name/Template'
					className={styles.broadcastFilters__search}
					allowClear
					enterButton
				/>
			</Col>
			<Col hidden={view !== 'LIST'}>
				<Select
					placeholder='Select Broadcast Status'
					onChange={value => onStatus(value as BroadcastStatus)}
					value={selectedStatus}
					options={[
						{
							label: 'All',
							value: 'ALL',
						},
						{
							label: 'Draft',
							value: 'DRAFT',
						},
						{
							label: 'Scheduled',
							value: 'SCHEDULED',
						},
						{
							label: 'Completed',
							value: 'COMPLETED',
						},
						{
							label: 'Canceled',
							value: 'CANCELED',
						},
						{
							label: 'In Process',
							value: 'IN_PROCESS',
						},
					]}
				/>
			</Col>
			<Col>
				<Radio.Group
					className={styles.broadcastFilters__radio}
					value={view}
					onChange={e => onView(e.target.value)}
					buttonStyle='solid'
				>
					<Radio.Button value='LIST'>
						<RiListCheck /> List
					</Radio.Button>
					<Radio.Button value='STATS'>
						<RiLineChartLine /> Statistics
					</Radio.Button>
				</Radio.Group>
			</Col>
		</Row>
	)
}

export default BroadcastsFilters
